import React from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ExitToApp as ExitIcon } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

/** Must match `drawerWidth` in `components/Artist/ArtistLayout.tsx`. */
const ARTIST_DRAWER_WIDTH_PX = 260;

const ImpersonationBanner: React.FC = () => {
  const history = useHistory();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isImpersonating = localStorage.getItem('impersonating') === 'true';
  const originalAdminUser = localStorage.getItem('originalAdminUser');

  const handleStopImpersonation = () => {
    // Restore original admin user and token
    const originalAdminToken = localStorage.getItem('originalAdminToken');
    if (originalAdminUser) {
      localStorage.setItem('user', originalAdminUser);
    }
    if (originalAdminToken) {
      localStorage.setItem('token', originalAdminToken);
    }
    
    // Clear impersonation data
    localStorage.removeItem('impersonating');
    localStorage.removeItem('impersonatedArtistId');
    localStorage.removeItem('originalAdminUser');
    localStorage.removeItem('originalAdminToken');
    
    history.push('/dashboard');
  };

  if (!isImpersonating) {
    return null;
  }

  // Do not cover the artist nav drawer (permanent drawer is under this if we span full width + high z-index).
  // Match ArtistLayout: AppBar is 64px tall; on md+ it starts after the drawer.
  const bannerTop = 64;
  const bannerStyle: React.CSSProperties = {
    position: 'fixed',
    top: bannerTop,
    left: isDesktop ? ARTIST_DRAWER_WIDTH_PX : 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 2,
  };

  return (
    <Box style={bannerStyle}>
      <Alert 
        severity="warning" 
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleStopImpersonation}
            startIcon={<ExitIcon />}
          >
            Stop Impersonation
          </Button>
        }
        style={{ borderRadius: 0 }}
      >
        <Typography variant="body2">
          <strong>Admin Impersonation Mode:</strong> You are currently viewing as an artist. 
          Click "Stop Impersonation" to return to the admin dashboard.
        </Typography>
      </Alert>
    </Box>
  );
};

export default ImpersonationBanner;
